import ApiCalling from "../network/ApiCalling";

export const getUpdatedSchool = async (id) => {
  try {
    const res = await ApiCalling.apiCallParamsGet(
      `school/get-module-access/${id}`
    );
    console.log("API Response in getUpdatedSchool:", res);
    return res?.data || res;
  } catch (err) {
    console.log("API error in getUpdatedSchool:", err);
    return null;
  }
};
